import { publicEnvSchema, type PublicEnv } from '@/config/env/schema'

let cached: PublicEnv | null = null

/** Variáveis públicas — seguras para importar no browser. */
export function getPublicEnv(): PublicEnv {
  if (cached) return cached
  const parsed = publicEnvSchema.safeParse({
    VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
    VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
    VITE_ALLOW_SELF_SIGNUP: import.meta.env.VITE_ALLOW_SELF_SIGNUP,
    VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  })
  if (!parsed.success) {
    const msg = parsed.error.issues.map(i => i.message).join('; ')
    throw new Error(`Configuração pública inválida: ${msg}. Copie .env.example para .env e preencha.`)
  }
  cached = parsed.data
  return cached
}

export const publicEnv = {
  get supabaseUrl() { return getPublicEnv().VITE_SUPABASE_URL },
  get supabaseAnonKey() { return getPublicEnv().VITE_SUPABASE_ANON_KEY },
  get allowSelfSignup() { return getPublicEnv().VITE_ALLOW_SELF_SIGNUP ?? false },
  get apiBaseUrl() { return getPublicEnv().VITE_API_BASE_URL ?? '' },
}
